import { Components, Theme } from '@mui/material';

import { PrimaryColors } from '../constants';

export const MuiMenuItem: Components<Theme>['MuiMenuItem'] = {
  styleOverrides: {
    root: {
      padding: '10px 16px',
      '&.Mui-selected': {
        backgroundColor: `${PrimaryColors.radical}`,
        '&.Mui-focusVisible': {
          backgroundColor: `${PrimaryColors.radical}`,
        },
        '&:hover': {
          backgroundColor: `${PrimaryColors.radical}`,
        },
      },
      '&:hover': {
        backgroundColor: `${PrimaryColors.carbon}`,
      },
      '&.Mui-focusVisible': {
        backgroundColor: `${PrimaryColors.carbon}`,
      },
    },
  },
};
